// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__Ia5sa","header":"PatientBlock_header__rGF-G","label":"PatientBlock_label__2JTxQ","option":"PatientBlock_option__1w0aQ"};